import ApiService from './api.service'

const ActivityLogService = {

  /***
   * Get account via slug
   * @param {number} payload.page page in query
   * @param {number} payload.pageSize number of results in query
   * @returns {*}
   */
  query (payload) {
    return ApiService.post('activity-log/query', payload)
  },
}
export default ActivityLogService
